module.exports = __webpack_public_path__ + "f5673772333bd2fa131854ed246576f6.png";